import React, { useState, useEffect } from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Chip } from 'primereact/chip';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import useFilters from '../hooks/useFilters';

const CompanyFilterBar = ({ 
  onFilterChange,
  showAdvanced = false,
  enterprises = [],
  layouts = [],
  initialFilters = {},
  filters: parentFilters = undefined
}) => {
  const initial = parentFilters || initialFilters;
  const { filters, setFilters, updateFilter, clearFilters: resetHookFilters } = useFilters(initial);
  
  const normalizeFilters = (source = {}) => {
    if (!source) return {
      enterpriseName: '',
      enterpriseEmail: '',
      responsibleName: '',
    };

    return {
      enterpriseName: source.enterprise_name || source.enterpriseName || '',
      enterpriseEmail: source.enterprise_email || source.enterpriseEmail || '',
      responsibleName: source.responsible_name,
    };
  };

  const [localFilters, setLocalFilters] = useState(normalizeFilters(initial));
  const [activeFilters, setActiveFilters] = useState([]);

  // Sincroniza filtros quando mudam externamente ou via hook
  useEffect(() => {
    // Se o pai controla via parentFilters, respeitar.
    // Caso contrário, sincronizar somente quando houver mudança real de filtros.
    if (parentFilters) {
      setLocalFilters(normalizeFilters(parentFilters));
      return;
    }

    setLocalFilters(normalizeFilters(filters));
  }, [parentFilters, filters]);

  // Atualiza os chips de filtros ativos
  useEffect(() => {
    const active = [];
    if (localFilters.enterpriseName) active.push('Cliente');
    if (localFilters.enterpriseEmail) active.push('Email');
    if (localFilters.responsibleName) active.push('Responsável');
    setActiveFilters(active);
  }, [localFilters]);

  const handleFilterChange = (field, value) => {
    const newFilters = { ...localFilters, [field]: value };
    setLocalFilters(newFilters);

    const filterToSend = {
      enterprise_name: newFilters.enterpriseName,
      enterprise_email: newFilters.enterpriseEmail,
      responsible_name: newFilters.responsibleName,
    };

    // dispara alteração no hook e também no callback externo
    setFilters(filterToSend);
    if (onFilterChange) onFilterChange(filterToSend);
  };


  const clearFilters = () => {
    const emptyFilters = {
      enterpriseName: '',
      enterpriseEmail: '',
      responsibleName: '',
    };

    // força o re-render da UI
    setLocalFilters(emptyFilters);

    // limpa o hook
    resetHookFilters();
    const filterToSend = {
      enterprise_name: undefined,
      enterprise_email: undefined,
      responsible_name: undefined,
    };
    setFilters(filterToSend);

    if (onFilterChange) {
      onFilterChange({
        enterprise_name: '',
        enterprise_email: '',
        responsible_name: '',
      });
    }
  };

  const removeFilter = (filterName) => {
    switch (filterName) {
      case 'Cliente':
        handleFilterChange('enterpriseName', '');
        break;
      case 'Email':
        handleFilterChange('enterpriseEmail', '');
        break;
      case 'Responsável':
        handleFilterChange('responsibleName', '');
        break;
    }
  };

  return (
     <div style={{marginLeft:'10px', marginRight:'10px'}}>
      {/* Active Filters Chips */}
      {activeFilters.length > 0 && (
        <div style={{marginLeft:'-10px', alignItems: 'center'}} className="flex flex-wrap mb-2">
          <span className="text-sm text-gray-600 self-center mr-2">
            Filtros ativos:
          </span>
          {activeFilters.map((filter, index) => (
            <Chip 
              key={index}
              label={filter}
              removable
              onRemove={() => removeFilter(filter)}
              className="text-sm"
              style={{ height:'25px' }}
            />
          ))}
          <Button
            label="Limpar todos"
            icon="pi pi-times-circle"
            variant="outlined"
            className="p-button-text p-button-sm"
            onClick={clearFilters}
          />
        </div>
      )}

      {/* Main Filters */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
        {/* Enterprise Filter */}
        <div className="flex flex-column gap-2">
          <label htmlFor="enterpriseFilter" className="text-sm font-medium text-gray-700">
            Cliente
          </label>
          <span className="p-input-icon-left w-full relative flex items-center">
           <InputIcon className="pi pi-building" />
            <InputText
              id="enterpriseFilter"
              icon="pi pi-building"
              placeholder="Buscar cliente..."
              value={localFilters.enterpriseName}
              onChange={(e) => handleFilterChange('enterpriseName', e.target.value)}
              className="w-full p-inputtext-sm"
            />
          </span>
        </div>

        {/* Email Filter */}
        <div className="flex flex-column gap-2">
          <label htmlFor="emailFilter" className="text-sm font-medium text-gray-700">
            Email
          </label>
          <span className="p-input-icon-left w-full">
            <InputIcon className="pi pi-list" />
            <InputText
              id="emailFilter"
              placeholder="Buscar email..."
              value={localFilters.enterpriseEmail}
              onChange={(e) => handleFilterChange('enterpriseEmail', e.target.value)}
              className="w-full p-inputtext-sm"
            />
          </span>
        </div>

        {/* Responsible Filter */}
        <div className="flex flex-column gap-2">
          <label htmlFor="responsibleFilter" className="text-sm font-medium text-gray-700">
            Responsável
          </label>
          <span className="p-input-icon-left w-full">
            <InputIcon className="pi pi-user" />
            <InputText
              id="responsibleFilter"
              placeholder="Buscar responsável..."
              value={localFilters.responsibleName}
              onChange={(e) => handleFilterChange('responsibleName', e.target.value)}
              className="w-full p-inputtext-sm"
            />
          </span>
        </div>
      </div>
    </div>
  );
};

export default CompanyFilterBar;